import { ItemOption, ItemResponse } from '@models/item';
import { CreateOrderRequest } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export const REMOVE_OPTION = -9999;

export interface UpdateOptionQuantityPayload {
    option: ItemOption;
    optionGroupId: string;
    amount: number;
    item: ItemResponse;
}

export function updateOptionQuantity(
  state: WritableDraft<CreateOrderRequest>,
  action: PayloadAction<UpdateOptionQuantityPayload>,
) {
  const {
    optionGroupId, option, amount, item,
  } = action.payload;
  const { orderLines } = state;
  const allOptionGroups = [...item.defaultOptionGroups, ...item.personalOptionGroups];
  const optionGroup = allOptionGroups
    .find((og) => og.optionGroupId === optionGroupId)!;

  const currentOrderLineIndex = orderLines.findIndex((orderLine) => orderLine.shopItemId === item.id);
  if (currentOrderLineIndex === -1) {
    return;
  }
  const currentOrderLine = orderLines[currentOrderLineIndex];

  if (currentOrderLine) {
    const field = currentOrderLine.personalOptions
      .find((opt) => opt.optionGroupId === optionGroupId)
      ? 'personalOptions' : 'defaultOptions';

    // 옵션 제거
    if (amount === REMOVE_OPTION) {
      console.log('remove option', field);
      console.log({ optionGroupId, option });
      state.orderLines[currentOrderLineIndex][field] = state.orderLines[currentOrderLineIndex][field]
        .map((og) => {
          if (og.optionGroupId === optionGroupId) {
            og.options = og.options.filter((opt) => opt.shopOptionId !== option.optionId);
          }
          return og;
        });
      console.log(state.orderLines);
      return;
    }

    // 라디오인 경우
    if (optionGroup.uiButtonType === 'RADIO') {
      state.orderLines[currentOrderLineIndex][field] = state.orderLines[currentOrderLineIndex][field]
        .map((og) => {
          if (og.optionGroupId === optionGroupId) {
          //  선택한 옵션만 남기기
            og.options = [{
              shopOptionId: option.optionId,
              optionName: option.name,
              optionPrice: option.salePrice,
              quantity: 1,
              totalAmount: option.salePrice,
              maxQuantity: option.maxQuantity,
            }];
          }
          return og;
        });
      return;
    }

    // 체크박스인 경우
    const currentSelectionCount = currentOrderLine[field]
      .find((og) => og.optionGroupId === optionGroupId)
      ?.options?.reduce((acc, cur) => acc + cur.quantity, 0) || 0;

    const newCount = currentSelectionCount + amount;
    if (newCount > optionGroup.maxSelection || newCount < 0) {
      return;
    }
    state.orderLines[currentOrderLineIndex][field] = state.orderLines[currentOrderLineIndex][field]
      .map((og) => {
        if (og.optionGroupId === optionGroupId) {
          let options = [...og.options];
          // 이미 선택된 경우
          if (options.find((opt) => opt.shopOptionId === option.optionId)) {
            options = options.map((opt) => {
              if (opt.shopOptionId === option.optionId) {
                opt.quantity += amount;
              }
              return opt;
            }).filter((opt) => opt.quantity > 0);
          } else { // 신규 추가
            options.push({
              shopOptionId: option.optionId,
              optionName: option.name,
              optionPrice: option.salePrice,
              quantity: amount,
              totalAmount: option.salePrice,
              maxQuantity: option.maxQuantity,
            });
          }
          og.options = options;
        }
        return og;
      });
  }
}

export function resetPersonalOptions(state: WritableDraft<CreateOrderRequest>) {
  state.orderLines = state.orderLines.map((orderLine) => {
    // 퍼스널 옵션 초기화
    orderLine.personalOptions = orderLine.personalOptions.map((personalOptionGroup) => {
      personalOptionGroup.options = [];
      return personalOptionGroup;
    });
    return orderLine;
  });
}
